import { SessionSiteSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';
import { AppState } from '~src/bootstrap/redux/state/AppState';
import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { createFlowSubscription } from '~src/flow/actions/CreateFlowSubscriptionReduxAction';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { Messages } from '../../codegen/Localize';
import { isSingleUnpublishedFlowDraft } from '../../spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';
import { ICreateSubscriptionAction } from '../../spacesPlatform/models/actionNames';
import { IContentInfo } from '../../spacesPlatform/models/IContentInfo';

export const CreateFlowSubscriptionEntityAction: IEntityAction<IContentInfo<'flow'>, ICreateSubscriptionAction> = {
  name: EntityActionNames.CreateFlowSubscription,
  translateName: Messages.flowSubscriptionsReduxActionName,
  isVisible: (_, state: AppState) => state ? SessionSiteSelectors.isFlowOutputSubscriptionsEnabled(state) : SessionSiteSelectors.isFlowOutputSubscriptionsEnabled(getAppStore().getState()),
  isClickable: (availableActions: ICreateSubscriptionAction, targetItems) => !!availableActions && availableActions.createSubscription &&
    !isSingleUnpublishedFlowDraft(targetItems),
  createReduxAction: (targetItems: IContentInfo[]) => createFlowSubscription(targetItems[0])
};
